import React from 'react';
import './Loader.css';

export const Loader = () => (
  <div className="loaderContainer">
    <div className="loader">Loading...</div>
  </div>
);
